import { NavigationMenuContent } from '@/components/NavigationMenu';
import {
  CloseButton,
  DataList,
} from '@/components/NewHeader/NavBar/helperComponents';
import { useTranslation } from '@/contexts/dictionaryContext';
import useGTMEvents from '@/hooks/useGTMEvents';
import { usePromotionalCatalogs } from '@/hooks/usePromotionalCatalogs';

export function Offers() {
  const {
    newHeader: { nav, search },
  } = useTranslation();
  const { sicily, puglia } = usePromotionalCatalogs();
  const { sendMenuClickEvent } = useGTMEvents();

  const section = nav.find((item) => item.id === 'offers')?.title || 'Offers';

  const columns = [
    {
      title: search.regions.sicily,
      items: sicily,
    },
    {
      title: search.regions.puglia,
      items: puglia,
    },
  ].filter((column) => column.items.length > 0);

  const handleItemClick = (item: { title: string; href: string }) =>
    sendMenuClickEvent({ section, sectionItem: item.title });

  return (
    <NavigationMenuContent className="left-0 right-auto mx-0">
      <div className="grid grid-cols-1 gap-4">
        <div className="py-12 px-20 space-y-6">
          <p className="uppercase font-bold">{section}</p>
          <div
            className={`grid gap-20 gap-y-6 ${
              columns.length > 1 ? 'grid-cols-2' : 'grid-cols-1'
            }`}>
            {columns.map((column) => (
              <DataList
                key={column.title}
                scrollable
                onItemClick={handleItemClick}
                data={{
                  title: column.title,
                  items: column.items,
                }}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="flex justify-center pb-2">
        <CloseButton />
      </div>
    </NavigationMenuContent>
  );
}
